import { gql } from "graphql-tag";

export const feedbackForm = pageType => gql`
  fragment ${pageType}_feedback_form on ${pageType}BodyFeedback_form {
     type
}`;
